import React,{useState} from 'react';
import './App.scss';
import {Footer,Features,Story,Homes,Realtors,Gallery,Sidebar,Header} from './Layout/index'
function App() {
  const [ isOpen,setIsOpen ] = useState(false);
  const toggleSidebar = () => {
    console.log(isOpen)
    setIsOpen(!isOpen);
  };
  return (
    <div className="container">
      <Sidebar isOpen={ isOpen } toggleSidebar={toggleSidebar}/>
      <Header />
      <Realtors />
      <Features />
      <Story />
      <Homes />
      <Gallery />
      <Footer />

    </div>
  );
}

export default App;
